export default {
    notificationCenter: "Central de Notificações",
    cleanNotifications: "Limpar Notificações",
    noNotifications: "Sem Notificações para você!"
}